<div class="info-page">
  <header class="info-hero">
    <p class="info-kicker">Your data</p>
    <h1 class="info-heading">Privacy Policy</h1>
    <p class="info-sub">What we collect, why we collect it, and who we share it with.</p>
  </header>

  <div class="info-highlights">
    <span class="info-chip">Orders &amp; accounts</span>
    <span class="info-chip">Payments only as needed</span>
    <span class="info-chip">Necessary cookies</span>
  </div>

  <div class="info-grid info-grid--two">
    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--teal">i</span> What we collect</h2>
      <p>We collect personal data required to deliver services and process orders, including: names, email and physical addresses, login credentials, and payment information (card or payment provider identifiers)</p>
      <p>We collect data to:</p>
      <ul>
        <li>provide and fulfil orders</li>
        <li>process payments and refunds</li>
        <li>communicate account and service information</li>
      </ul>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--wine">$</span> Who we share with</h2>
      <p>We share necessary data with third party (Payment gateway) to deliver the payment processors (for payments/refunds)</p>
      <p>We share only the card information with payment gateway</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--gold">C</span> Cookies and Trackers</h2>
      <p>We use cookies and similar technologies to operate the site. Cookies are strictly necessary (session/auth).</p>
    </article>

    <article class="info-card">
      <h2 class="info-block-title"><span class="info-icon info-icon--purple">R</span> Your rights</h2>
      <p>Users' rights in relation to their data, e.g. the right to request the deletion of their personal data; for deletion of personal data user can reach out to us through contact us page</p>
    </article>
  </div>

  <article class="info-card info-card--wide info-card--footer">
    <h2 class="info-block-title"><span class="info-icon info-icon--coral">&#64;</span> Contact</h2>
    <p>Questions about your data? Reach us here:</p>
    <a class="info-cta" routerLink="/Contact">Contact us</a>
  </article>
</div>
